import React, { useState } from 'react'
import LoginForm from '../auth/LoginForm'
import { useDispatch } from 'react-redux'
import { authenticate } from 'redux/actions/authentication'
import { useRouter } from 'next/router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullseyeArrow } from '@fortawesome/pro-light-svg-icons'

interface ChallengeSpaceLoginProps {
	spaceId: string
	title?: string
}

const ChallengeSpaceLogin = ({ title, spaceId }: ChallengeSpaceLoginProps) => {
	const [error, setError] = useState<any>('')
	const [loading, setLoading] = useState<boolean>(false)
	const dispatch = useDispatch()
	const router = useRouter()

	const onLoginSubmit = async (formData) => {
		setLoading(true)
		// Redirect to intended route if exists
		try {
			await dispatch(authenticate(formData))
			setLoading(false)
			router.push(
				'/account/challenge-spaces/[challengeSpaceId]?tab=challenges',
				`/account/challenge-spaces/${spaceId}?tab=challenges`
			)
		} catch (error: any) {
			setLoading(false)
			const errorText = error.message ? error.message : error
			return setError(errorText)
		}
	}

	return (
		<>
			<h3 className="text-xl mb-4 font-sans font-semibold text-gray-900">
				{title ?? 'Login to submit a challenge'}
			</h3>
			{loading ? (
				<div className="absolute inset-0 h-full flex items-center justify-center z-20">
					<FontAwesomeIcon icon={faBullseyeArrow} size="2x" spin />
				</div>
			) : (
				<LoginForm onFormSubmit={onLoginSubmit} error={error} />
			)}
		</>
	)
}

export default ChallengeSpaceLogin
